const supportURL = "https://support.geoscape.com.au";
const stripeUrl = "https://stripe.com/en-au";

export { supportURL, stripeUrl };
